import { SET_FROM_SEARCH_OFFER } from '../constants/searchOffer';

export const setFromSearchOfferAction = (payload) => ({
  type: SET_FROM_SEARCH_OFFER,
  payload,
});
